import { contactUrl } from "@constants/Env";
import { clickAction } from "@lib/util/analytics";
import * as WebBrowser from "expo-web-browser";

export default function openContact() {
  clickAction("Contact");
  WebBrowser.openBrowserAsync(contactUrl);
}
